import React from 'react';

const Footer = ({ navigateToHome, navigateToBlog, navigateToB2B, navigateToPrivacy, navigateToTerms, navigateToAbout, navigateToSitemap }) => (
  <footer className="bg-gray-900 text-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
        {/* Logo and Description */}
        <div className="md:col-span-2">
          <h3 className="text-2xl font-bold text-blue-400 mb-4">FogPortál.hu</h3>
          <p className="text-gray-300 mb-6 max-w-md">
            Magyarország országos fogászati portálja. Találja meg a legjobb fogorvosokat 
            és fogászati klinikákat egyszerűen, gyorsan és hatékonyan.
          </p>
          <div className="flex space-x-4">
            <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
              </svg>
            </a>
            <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"/>
              </svg>
            </a>
            <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M13.397 20.997v-8.196h2.765l.411-3.209h-3.176V7.548c0-.926.258-1.56 1.587-1.56h1.684V3.127A22.336 22.336 0 0 0 14.201 3c-2.444 0-4.122 1.492-4.122 4.231v2.355H7.332v3.209h2.753v8.202h3.312z"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-lg font-semibold mb-4">Gyors linkek</h4>
          <ul className="space-y-2">
            <li><button onClick={navigateToHome} className="text-gray-300 hover:text-blue-400 transition-colors">Főoldal</button></li>
            <li><button onClick={navigateToB2B} className="text-gray-300 hover:text-blue-400 transition-colors">Fogorvosoknak</button></li>
            <li><button onClick={navigateToSitemap} className="text-gray-300 hover:text-blue-400 transition-colors">Oldaltérkép</button></li>
          </ul>
        </div>

        {/* Legal and Support */}
        <div>
          <h4 className="text-lg font-semibold mb-4">Információk</h4>
          <ul className="space-y-2">
            <li><button onClick={navigateToPrivacy} className="text-gray-300 hover:text-blue-400 transition-colors">Adatkezelési tájékoztató</button></li>
            <li><button onClick={navigateToTerms} className="text-gray-300 hover:text-blue-400 transition-colors">ÁSZF</button></li>
            <li><button onClick={navigateToB2B} className="text-gray-300 hover:text-blue-400 transition-colors">Kapcsolat</button></li>
            <li><button onClick={navigateToAbout} className="text-gray-300 hover:text-blue-400 transition-colors">Rólunk</button></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-gray-800 mt-12 pt-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2025 FogPortál.hu. Minden jog fenntartva.
          </p>
          <p className="text-gray-400 text-sm mt-4 md:mt-0">
            Készítette: <span className="text-blue-400">FogPortál Csapat</span>
          </p>
        </div>
      </div>
    </div>
  </footer>
);


export default Footer;
